import { atom, useAtom } from 'jotai';

export type TreeNode = {
  label: string;
  value: string | number;
  children?: Record<number | string, TreeNode>;
};

export type DataMap = Record<number | string, TreeNode>;

export type SelectionTreeNode = TreeNode & {
  isSelected?: boolean;
  isPartialSelected?: boolean;
  children?: Record<string | number, SelectionTreeNode>;
};

export type SelectionMap = Record<string | number, SelectionTreeNode>;

const latestProjectStageFilterAtom = atom<SelectionMap>({});

export const useLatestProjectStageFilterState = () => {
  const [latestProjectStageFilterState, setLatestProjectStageFilterState] = useAtom(
    latestProjectStageFilterAtom,
  );

  const resetLatestProjectStageFilterState = () => {
    setLatestProjectStageFilterState({});
  };

  return {
    latestProjectStageFilterState,
    setLatestProjectStageFilterState,
    resetLatestProjectStageFilterState,
  };
};
